import React from 'react';
import { PRIMARY_COLORS } from '../../common/colors';

// OCL icon, canonical design-system artwork (assets/logo/icon/Icon-Blue.svg), recolorable via `color`.
// Decorative: aria-hidden below is correct because the caller supplies the accessible name —
// Header's home link wraps this in aria-label={t('nav.home_aria')}.
const OclLogo = ({ color = PRIMARY_COLORS.main, height = 28 }) => (
  <svg height={height} viewBox="0 0 306.14 111.63" fill={color} aria-hidden="true">
    <circle cx="54.09" cy="55.33" r="54.09" />
    <path d="M177.31,109.42c-29.87,0-54.09-24.22-54.09-54.09s24.22-54.09,54.09-54.09" />
    <circle cx="222.74" cy="28.04" r="27.04" />
    <circle cx="222.74" cy="84.4" r="27.04" />
    <circle cx="279.1" cy="84.4" r="27.04" />
  </svg>
);

export default OclLogo;
